import {State} from "@ispm-client/modules/process-executor/store";
import {createSelector, MemoizedSelector} from "@ngrx/store";
import {selectBpmnProcessState} from "@ispm-client/modules/process-executor/store/selectors/bpmn-process-state.selector";
import {NodeDependencies} from "@ispm/shared/bpmn/models/node-dependencies";

const getNodesDependencies = (state: State): NodeDependencies => state.nodeSelectionDependencies;

export const selectNodesDependencies: MemoizedSelector<
  object,
  any
  > = createSelector(selectBpmnProcessState, getNodesDependencies);

